import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { getClasses } from "@/http/coursesApi";
import { getCookie } from "@/utils/cookies";
import { getCourseClassesQueryKey } from "@/utils/queryKeys";
import type { CourseClass } from "@/@types/courses.types";

// Единый диапазон для всех потребителей /classes/ (список групп, cross-lookup в
// «Ваши занятия»). Одно окно — один кэш-ключ, данные шарятся без дублирующих запросов.
export const CLASSES_RANGE_DAYS = 60;

const toLocalYmd = (d: Date) => format(d, "yyyy-MM-dd");

export const computeClassesRange = () => {
  const start = new Date();
  const end = new Date();
  end.setDate(start.getDate() + CLASSES_RANGE_DAYS);
  return { startStr: toLocalYmd(start), endStr: toLocalYmd(end) };
};

export const useGetCourseClassesQuery = (clubId: string | null) => {
  const userToken = getCookie("user_token");
  const { startStr, endStr } = computeClassesRange();

  return useQuery<CourseClass[]>({
    queryKey: [...getCourseClassesQueryKey(clubId ?? "", startStr, endStr), { userToken }],
    queryFn: async () => {
      if (!clubId) return [];
      const response = await getClasses(clubId, startStr, endStr, userToken || undefined);
      return response.data.data ?? [];
    },
    enabled: !!clubId,
    staleTime: 60_000,
  });
};
